module.exports = __webpack_public_path__ + "img/bg_popup_1@2x.becc1a53.png";